import React from 'react';
import PropTypes from 'prop-types';
import { EmailSenderComponent } from './InvoiceEmailSender';
import { useRadiologistEmailSender } from '../../hooks/radiologists/useRadiologistEmailSender';

const RadiologistInvoiceEmailSender = ({ invoiceId, onEmailSent }) => {
  const { loading, sendEmail } = useRadiologistEmailSender();

  const handlePreviewReport = async () => {
    await sendEmail(invoiceId);
    onEmailSent?.();
  };

  return (
    <EmailSenderComponent
      title="Send Email"
      placement="left"
      loading={loading}
      onClick={handlePreviewReport}
    />
  );
};

RadiologistInvoiceEmailSender.propTypes = {
  invoiceId: PropTypes.number,
  invoiceNo: PropTypes.string,
  onEmailSent: PropTypes.func,
};

export default RadiologistInvoiceEmailSender;
